import React, { useState, useRef, useCallback } from 'react';
import cn from 'classnames';
import I18n from '@utils/i18n';
import { getClient } from '@api/feedStream'
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import styles from './index.module.less';
import update from 'immutability-helper';
import { inject, observer } from 'mobx-react';
import EmptyComponent from '@components/EmptyComponent';
import CommentComponent from '@components/CommentComponent';
import { ScrollLoading } from '@components/index';

const Count = ({ count, className, text }) => {
  return (
    <p className={cn(styles.headTitle, className)}>
      <span className={'DINPro-Medium'}>{count}</span>
      <span className={'Medium'}>{text}</span>
    </p>
  )
}

const getCustomerMisc = (userStore) => {
  return {
    avatar: userStore.socialUserInfo.avatar,
    customerId: userStore.socialUserInfo.customerId,
    nickName: userStore.socialUserInfo.nickName,
    intro: userStore.socialUserInfo.intro,
    vipLevel: userStore.socialUserInfo.vipLevel
  }
}

const T = (props) => {
  const { comments: defaultComments, commentCount, userStore, postData, pushCommentsRef, nextId } = props;
  const [comments, setComments] = useState(defaultComments);
  const commentsRef = useRef(defaultComments)
  const [status, setStatus] = useState()
  const nextIdRef = useRef(nextId)
  const [visibleInput, setVisibleInput] = useState(''); // 评论、回复的输入框互斥，只能显示其中一个 这里存数据Id
  pushCommentsRef.current = (params) => {
    const comment = {
      ...params?.[0]?.res,
      likeCount: params?.[0]?.res?.likeCount ?? 0,
      replyCount: params?.[0]?.res?.replyCount ?? 0,
      replies: params?.[0]?.res?.replyCount ?? [],
      customerMisc: getCustomerMisc(userStore)
    }
    commentsRef.current = [comment, ...commentsRef.current];
    setComments(commentsRef.current);
  }
  const pushReply = useCallback((commentId, params) => {
    const { res, targetComment } = params;
    const index = commentsRef.current.findIndex(item => commentId === item.id)
    const reply = {
      ...res,
      likeCount: params?.[0]?.res?.likeCount ?? 0,
      replyCount: params?.[0]?.res?.replyCount ?? 0,
      customerMisc: getCustomerMisc(userStore),
      targetCustomerMisc: targetComment.customerMisc
    }
    commentsRef.current = update(commentsRef.current, {
      [index]: {
        replies: {
          $unshift: [reply]
        }
      }
    })
    setComments(commentsRef.current);
  }, [])
  const fetchData = useCallback(async (unObserver) => {
    if (!nextIdRef.current) {
      return
    }
    setStatus('loading')
    try {
      const query = {
        activity_id: postData.id,
        kind: 'COMMENT',
        limit: 10,
        id_lte: nextIdRef.current
      };
      const data = await getClient().reactions.filter(query)
      if (!data.result?.length) {
        unObserver()
        setStatus('success')
        return
      }
      commentsRef.current = [...commentsRef.current, ...data.result]
      setComments(commentsRef.current);
      nextIdRef.current = data.nextId
    } catch (error) {
    }
    setStatus('success')
  }, [])
  useIsomorphicLayoutEffect(() => {
    setComments(defaultComments);
    commentsRef.current = defaultComments;
    nextIdRef.current = nextId;
    setVisibleInput('')
  }, [defaultComments, nextId])
  return (
    <div className={cn(styles.container)}>
      <Count count={commentCount} text={I18n.t('eu2p41TW')} />
      {!comments?.length && (
        <EmptyComponent
          desc={I18n.t('noPostComment')}
          source={require('@images/noComment.webp')}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 80 }}
          textStyle={styles.emptyTextStyle}
        />
      )}
      {!!comments?.length && (
        <ScrollLoading fetchData={fetchData} invisibleHeight={200} status={status}>
          {
            comments.map(item => {
              return (
                <div className={styles.item} key={item.id}>
                  <CommentComponent
                    commentData={item}
                    userStore={userStore}
                    itemData={postData}
                    visibleInput={visibleInput}
                    setVisibleInput={setVisibleInput}
                    fetchPostComment={(...args) => pushReply(item.id, ...args)}
                  />
                </div>
              )
            })
          }
        </ScrollLoading>
      )}
    </div>
  )
}

export const Comments = inject(rootStore => {
  return {
    userStore: rootStore.store.userStore
  }
})(observer(T))
